import React from "react";

import { Box, Flex, Text, Textarea } from "@chakra-ui/react";

import Group from "../../../pages/ServicosAcolhimento/Visualizar/Group";

export const SituacaoAdocao = ({ dataAdocao }) => {
  return dataAdocao ? (
    <>
      <Box className="break-page">
        <Flex>
          <Group
            bgColor="#fff"
            title="SITUAÇÃO QUANTO À ADOÇÃO"
            py="12px"
            mtDivider="5px">
            <Flex mt={6}>
              <Text as="b">Cumpre Requisitos para Adoção? </Text>
            </Flex>
            <Text textAlign="justify" mt={2}>
              {""}
              {dataAdocao?.cumpreRequisitoAdocao === "S" ? "Sim" : "Não"}
              {dataAdocao?.motivoAptoAdocao?.descricao
                ? ` - ${dataAdocao?.motivoAptoAdocao?.descricao}`
                : ""}
            </Text>
            <Box mt={2}>
              <Text as="b">Observações: </Text>

              <Flex flexDir="column" position="relative">
                <Textarea
                  mt={2}
                  defaultValue={`${
                    dataAdocao?.observacao ? dataAdocao?.observacao : ""
                  }`}
                  name="observacao"
                  id="observacao"
                  backgroundColor="#fff"
                  autoComplete="off"
                  disabled={true}
                  sx={{
                    "&:disabled": {
                      backgroundColor: "inherit",
                      borderColor: "inherit",
                      "&:hover": {
                        borderColor: "inherit",
                      },
                    },
                  }}
                  placeholder="Informe as Observações"
                  maxLength={255}
                />
                <Text
                  zIndex={0}
                  fontSize="sm"
                  position="absolute"
                  bottom="5px"
                  right="15px"
                  color={
                    dataAdocao?.observacao &&
                    dataAdocao?.observacao.length === 255
                      ? "red"
                      : "gray"
                  }>
                  {dataAdocao?.observacao
                    ? `${dataAdocao?.observacao.length}/255`
                    : "0/255"}
                </Text>
              </Flex>
            </Box>
          </Group>
        </Flex>
      </Box>
    </>
  ) : (
    <Box className="break-page">
      <Flex>
        <Group
          bgColor="#fff"
          title="SITUAÇÃO QUANTO À ADOÇÃO"
          mt="15px"
          py="12px"
          mtDivider="5px"
        />
      </Flex>
    </Box>
  );
};
